import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";

const ReportTypeSelector = ({
  t,
  reportsOptions,
  selectedReportOption,
  onSelectReportOption,
}) => (
  <div className={styles.filterItem}>
    <span className={styles.filterItemLabel}>{t("pages.reports.reportLabel")}</span>
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t("pages.reports.reportType")}</label>
      <Select
        options={reportsOptions}
        value={selectedReportOption}
        onChange={onSelectReportOption}
        placeholder={t("pages.reports.reportTypePlaceholder")}
        styles={compactSelectStyles}
      />
    </div>
  </div>
);

export default ReportTypeSelector;
